import { Outlet } from "react-router-dom";

export function PatientAuthLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-white">

      {/* ── Left panel — logo + form slot ── */}
      <div className="flex w-[55%] flex-col">

        {/* Logo — pinned at top, same size/style as PatientSidebar */}
        <div className="flex shrink-0 items-center gap-3 pl-14 pr-4 pt-8 pb-4">
          <img src="/logo.png" alt="MedSyncIQ" className="h-10 w-10 rounded-lg object-contain" />
          <div className="flex flex-col gap-0">
            <h1
              className="text-lg leading-tight tracking-tight text-[#0A2947]"
              style={{ fontWeight: 900, letterSpacing: "-0.02em" }}
            >
              MedSyncIQ
            </h1>
            <p className="text-[11px] font-medium leading-tight text-[#4B5563]">
              Healthcare Platform
            </p>
          </div>
        </div>

        {/* Form slot — top-aligned so nothing scrolls out of view above the fold */}
        <div className="flex flex-1 flex-col items-center overflow-y-auto px-8 pb-8 pt-6">
          <Outlet />
        </div>
      </div>

      {/* ── Right panel — image ── */}
      <div className="flex flex-1 p-4">
        <div className="relative flex-1 overflow-hidden rounded-3xl">
          <img
            src="/Image1.png"
            alt="Healthcare professionals"
            className="h-full w-full object-cover object-center"
          />
        </div>
      </div>

    </div>
  );
}
